import auth0 from 'auth0-js';

const authClient = new auth0.WebAuth({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientID: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: `${window.location.origin}/callback`,
  responseType: 'token id_token',
  scope: 'openid email',
});

export default authClient;
